<div style="display: flex; flex-direction: row; font-size: 20px">
    <div style="display: flex; flex-direction: row">
        <div class="underline-on-hover text" style="margin: 5px 5px 5px 0; text-align: center; cursor: pointer">
            <span class="text icon-home"></span>
        </div>

        @if (orgPath?.length) {
            <span class="text icon-chevron-right" style="margin: 5px"></span>
        }
    </div>

    @for (currentNode of orgPath; track currentNode) {
        <div style="display: flex; flex-direction: row">
            <div
                (click)="changeNode(currentNode)"
                class="underline-on-hover text"
                style="margin: 5px; text-align: center; cursor: pointer"
            >
                {{ currentNode?.orgDescription }}
            </div>

            @if (!$last) {
                <span class="text icon-chevron-right" style="margin: 5px"></span>
            }
        </div>
    }
</div>
